import axios from "axios";
import {
    BusinessContractorDTO, UpdateBusinessContractorDetailsPayload,
} from "@/components/payroll/business/employments/contractors/Contractor";
import {BUSINESS_CONTRACTOR_SERVICE, BUSINESS_FOREIGN_CONTRACTOR_SERVICE} from "@/constants/endpoints";
import authHeader from "@/services/auth-header";
import TerminationPayloadDTO from "@/components/payroll/business/employments/contractors/TerminationPayloadDTO";
import ContractorDocumentDTO from "@/dto/contractor/ContractorDocumentDTO";
import AddContractorDocumentPayload from "@/dto/contractor/AddContractorDocumentPayload";

class BusinessContractorService {
    public getContractorById(contractorId: number) {
        return axios.get<BusinessContractorDTO>(`${BUSINESS_CONTRACTOR_SERVICE}/${contractorId}`, {headers: authHeader()})
    }

    public terminateContractor(payload: TerminationPayloadDTO) {
        return axios.put(`${BUSINESS_CONTRACTOR_SERVICE}/terminate`, payload, {headers: authHeader()})
    }

    public deleteContractor(contractorId: number) {
        return axios.delete(`${BUSINESS_CONTRACTOR_SERVICE}/${contractorId}`, {headers: authHeader()})
    }

    public updateContractor(payload: UpdateBusinessContractorDetailsPayload) {
        return axios.put(`${BUSINESS_CONTRACTOR_SERVICE}`, payload, {headers: authHeader()})
    }

    public getDocuments(contractorId: number) {
        return axios.get<Array<ContractorDocumentDTO>>(`${BUSINESS_CONTRACTOR_SERVICE}/${contractorId}/documents`, {headers: authHeader()});
    }

    addDocument(contractorId: number, payload: AddContractorDocumentPayload) {
        return axios.post(`${BUSINESS_CONTRACTOR_SERVICE}/${contractorId}/documents`, payload, {headers: authHeader()});
    }
}

export default new BusinessContractorService();